'use strict';

var React = require('react');
var withStyles = require('../../../node_modules/@material-ui/core/styles/withStyles.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var VerticalSpace = require('../../Layouts/VerticalSpace.js');
var PreparerDetails = require('../PreparerDetails.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  logo: {
    maxWidth: 200,
    minWidth: 100,
    maxHeight: 200,
    minHeight: 100
  }
};

var PageHeaderMobile = function PageHeaderMobile(props) {
  var classes = props.classes,
      title = props.title,
      customerName = props.customerName,
      address = props.address,
      logoUrl = props.logoUrl,
      preparer = props.preparer,
      number = props.number,
      date = props.date,
      settings = props.settings,
      isPresenting = props.isPresenting;
  var show_logo = settings.show_logo;
  var logo = show_logo && logoUrl && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement("img", {
    src: logoUrl,
    className: classes.logo
  }));
  if (ObjectHelper.isBlank(customerName)) return React__default["default"].createElement(Grid, {
    container: true,
    item: true,
    direction: "column",
    alignItems: "center"
  }, "'", logo, React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "h1"
  }, title)));
  return React__default["default"].createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center"
  }, logo, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "h1"
  }, title)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle2"
  }, customerName, " | ", address)), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(VerticalSpace, {
    height: 8
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(PreparerDetails, {
    preparer: preparer,
    number: number,
    date: date,
    settings: settings,
    isPresenting: isPresenting
  })));
};

var PageHeaderMobile$1 = withStyles(styles)(PageHeaderMobile);

module.exports = PageHeaderMobile$1;
